module.exports = __webpack_public_path__ + "img/7760108.2de3de78.png";